import { PresentationSlide, SlideObject } from '../types';

export interface ComponentPreviewBounds {
  x: number;
  y: number;
  w: number;
  h: number;
}

const MIN_SIZE = 1;
const PADDING = 24;

export function objectsBoundingBox(objects: SlideObject[]): ComponentPreviewBounds {
  if (!objects.length) return { x: 0, y: 0, w: MIN_SIZE, h: MIN_SIZE };
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const object of objects) {
    minX = Math.min(minX, object.x);
    minY = Math.min(minY, object.y);
    maxX = Math.max(maxX, object.x + object.w);
    maxY = Math.max(maxY, object.y + object.h);
  }
  return {
    x: Number.isFinite(minX) ? minX : 0,
    y: Number.isFinite(minY) ? minY : 0,
    w: Math.max(MIN_SIZE, maxX - minX),
    h: Math.max(MIN_SIZE, maxY - minY),
  };
}

export function fitComponentObjects(objects: SlideObject[]): {
  objects: SlideObject[];
  width: number;
  height: number;
} {
  const box = objectsBoundingBox(objects);
  return {
    width: box.w + PADDING * 2,
    height: box.h + PADDING * 2,
    objects: objects.map((object) => ({
      ...object,
      x: object.x - box.x + PADDING,
      y: object.y - box.y + PADDING,
    })),
  };
}

export function slideFromComponent(id: string, objects: SlideObject[]): PresentationSlide {
  const fitted = fitComponentObjects(objects);
  return {
    slideId: `component-preview-${id}`,
    order: 0,
    layoutId: 'component-preview',
    objects: fitted.objects,
    backgroundColor: '#FFFFFF',
  };
}

export function componentPreviewCanvas(objects: SlideObject[]): { width: number; height: number } {
  const fitted = fitComponentObjects(objects);
  return { width: fitted.width, height: fitted.height };
}
